import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import VideoPage from './components/VideoPage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <Routes>
        <Route
          exact path="/" element={<Home />}
          />
          <Route 
           path="/video/:id" element={<VideoPage />}
           />
      </Routes>
      </BrowserRouter>
      
    </div>
  );
}

export default App;
